import * as React from 'react';
type Props = {
  className?: string;
};
export function Trout({ className }: Props) {
  return (
    <svg
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Trout"
      className={className}
    >
      <path
        d="M1.77964 25.1899C5.7869 21.6481 19.1879 12.5254 40.8294 24.6884L47.699 21.2593C48.2629 20.9778 48.893 21.4997 48.7212 22.1063L47.4362 26.6456L48.721 31.3683C48.889 31.9857 48.2338 32.5025 47.6725 32.1953L40.8294 28.4517C40.8294 28.4517 20.005 43.1066 1.82227 27.6114C1.08238 26.9809 1.05124 25.8337 1.77964 25.1899Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.22708 27.0082C6.71526 27.0082 7.11104 26.6124 7.11104 26.1243C7.11104 25.6362 6.71526 25.2404 6.22708 25.2404C5.7389 25.2404 5.34314 25.6362 5.34314 26.1243C5.34314 26.6124 5.7389 27.0082 6.22708 27.0082Z"
        fill="currentColor"
      />
      <path
        d="M10.573 23.8359C10.573 23.8359 12.143 26.8777 10.573 29.7232"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.1722 26.8429L19.3188 26.6455L17.6203 31.7599L14.328 29.0404"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.0956 33.6198L32.8716 36.058L37.5043 33.4899L33.8853 32.175"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.2974 18.5429L24.4543 13.75L30.3231 19.9463"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
